import { useSelector } from 'store/store'
import { Skeleton } from '@mui/material'
import { HeadItemType, NotFound, SectionCard, Table } from 'components'

import * as S from './styles'

export const PartnersSection = () => {
  const {
    detailedInfo: { Parceiros },
    loadingDetailedInfo: loading
  } = useSelector((state) => state.ov)

  const headValues: HeadItemType[] = [
    { label: 'Tipo Parceiro', columnName: 'TipoParceiro' },
    { label: 'Código do Parceiro', columnName: 'CodigoParceiro' },
    { label: 'Nome do Parceiro', columnName: 'NomeParceiro' }
  ]

  const renderSkeleton = () => {
    const skeleton = []
    for (let i = 0; i < 3; i++) {
      skeleton.push({
        id: `partner-loading-${i}`,
        content: [
          <Skeleton key="partner-skeleton-1" width={200} height={30} />,
          <Skeleton key="partner-skeleton-2" width={125} height={30} />,
          <Skeleton key="partner-skeleton-3" height={30} />
        ]
      })
    }
    return skeleton
  }

  const renderBody = () => {
    const content = loading
      ? renderSkeleton()
      : Parceiros.map((partner, index) => {
          return {
            id: `partner-${index}`,
            content: [partner.Tipo, partner.Codigo, partner.Nome]
          }
        })

    return content
  }

  return (
    <SectionCard
      title="Parceiros"
      tooltipText="Nesta seção você pode ver as partes envolvidas na execução desta OV, contemplando fornecedores até próprio Executivo de Vendas."
    >
      <S.Wrapper>
        <>
          {!loading && !Parceiros.length ? (
            <NotFound
              title="Nenhum parceiro encontrado"
              description="Os parceiros relacionados à Ordem de Venda serão listados aqui."
            />
          ) : (
            <Table
              headData={headValues}
              rowHeight={32}
              bodyData={renderBody()}
              distributeWidth={false}
            />
          )}
        </>
      </S.Wrapper>
    </SectionCard>
  )
}
